module.exports = __webpack_public_path__ + "img/product_123.d8b1cc9.svg";